/**
 * ExportMenu — dropdown ancorado com PDF / Excel / CSV.
 *
 * Fecha em click-fora e ESC (padrao do kebab do EntityHeader). Cada item
 * chama `onExportar(formato)` no CrmBoard, que delega a `exportarCrm`.
 */
import React, { useEffect, useRef, useState } from "react";
import { FiDownload, FiFileText } from "react-icons/fi";

import { MenuItem, MenuList, MenuWrapper } from "./styles";

const FORMATOS = [
  { id: "pdf", label: "PDF estruturado" },
  { id: "excel", label: "Excel (.xlsx)" },
  { id: "csv", label: "CSV" },
];

function ExportMenu({ onExportar, disabled = false }) {
  const [aberto, setAberto] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!aberto) return undefined;
    function onClickFora(event) {
      if (!wrapperRef.current?.contains(event.target)) setAberto(false);
    }
    function onKey(event) {
      if (event.key === "Escape") setAberto(false);
    }
    document.addEventListener("mousedown", onClickFora);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onClickFora);
      document.removeEventListener("keydown", onKey);
    };
  }, [aberto]);

  const escolher = (formato) => {
    setAberto(false);
    onExportar(formato);
  };

  return (
    <MenuWrapper ref={wrapperRef}>
      <button
        className="btn btn--ghost"
        type="button"
        aria-haspopup="menu"
        aria-expanded={aberto}
        disabled={disabled}
        onClick={() => setAberto((v) => !v)}
      >
        <FiDownload size={15} aria-hidden="true" /> Exportar
      </button>
      {aberto && (
        <MenuList role="menu">
          {FORMATOS.map((f) => (
            <MenuItem key={f.id} role="none">
              <button type="button" role="menuitem" onClick={() => escolher(f.id)}>
                <FiFileText size={14} aria-hidden="true" /> {f.label}
              </button>
            </MenuItem>
          ))}
        </MenuList>
      )}
    </MenuWrapper>
  );
}

export default ExportMenu;
